import {createApi} from '@reduxjs/toolkit/query/react';
import baseQuery from 'src/redux/api/baseQuery';
import { AuditoriaListResponse, AuditoriasRequest } from './types/auditoria';

/**
 * API para la gestión de auditorias
 * @see https://redux-toolkit.js.org/rtk-query/overview
 * @see https://redux-toolkit.js.org/rtk-query/usage/customizing-queries
 *
 */
export const auditoriaApi = createApi({
	reducerPath: 'auditoriaApi',
	baseQuery,
	tagTypes: ['auditoria'],
	endpoints: (builder) => ({
		obtenerAuditorias: builder.query<AuditoriaListResponse, AuditoriasRequest>({
			query({ paginador, ...rest}) {
				return {
					url: 'v1/auditorias',
					method: 'GET',
					credentials: 'include',
					params: {
						...rest,
						...paginador
					}
				};
			},
		}),
	}),
});

export const {
	useObtenerAuditoriasQuery,
	useLazyObtenerAuditoriasQuery
} = auditoriaApi;
